import { durationStringToMinutes } from '@vendasta/meetings';

export function durationMinutes(duration: string): string {
  if (!duration) {
    return '';
  }
  const minutes = durationStringToMinutes({ duration });
  return `${minutes} min`;
}
